<div class="footer">
    <ul>
        <li><a routerLink="/portfolio">Portfolio</a></li>
        <li><a routerLink="/resume">Resume</a></li>
        <li><a routerLink="/gallery">Gallery</a></li>
        <li><a routerLink="/contact">Contact</a></li>
    </ul>
    <p class="copyright">&copy; 2020 Ibnu Imam</p>
</div>